<template>
<div>
    <div class="row">
        <b-media>
            <img slot="aside" src="src/assets/scena_light.jpg" alt="Media Aside" />

            <h2>Световое оборудование</h2>
            <p>Приборы полного вращения, сканеры, театральное и сценическое освещение, архитектурный свет, лазеры, управление светом, генераторы эффектов, силовое оборудование для света, лампы, светофильтры</p>

            <!-- [Optional: add media children here for nesting] -->
        </b-media>
        <app-alert v-if="load" show> </app-alert>
        <b-container fluid v-if="brand.card" >
             <h5 style="text-align:center;">Для отображения наличия товаров на удаленном складе нажмите кнопку <b-btn variant="outline-primary">Наличие</b-btn> у соответствующего бренда.</h5>
              <item-list :items = "items"></item-list>  

        </b-container>

        <Brand :brand = brand v-if="!brand.card" />

    </div>
</div>
</template>

<script>
import Vue from 'vue'

import ItemList from '../components/ItemList'
import AppAlert from "../components/AppAlert.vue"
import Brand from "../components/Brand.vue"

export default {
    created() {
        Vue.http.get(this.name + '.php')
            .then(response => {

                    this.items = response.data.rows
                    this.load = false
                    this.card = true
                },
                error => {
                    console.log(error)
                }
            )

    },
    data() {
        return {
            items: [],
            name: this.$route.name,
            load: true,
            
        }
    },
    computed:{
       brand(){
            return this.$store.getters['all/getBrand']
        }
    },
    methods: {


    },
    components: {
        AppAlert,
        ItemList,
        Brand
    },
    beforeDestroy(){
        this.$store.commit('all/clearBrand',{'brand':'','post':'','card':true})
    }

}
</script>

<style scoped>

.media {
    flex-wrap: wrap;
    align-items: center;
    margin: 0px 30px;
    justify-content: center;
    width: 85%;
}

.media p {
    text-align: justify;
}

.media img {
    width: 350px;
    height: 250px;
    margin: 10px;
}

.custom-select:hover {
    cursor: pointer;
}

@media(max-width: 560px) {
    .media img {
        width: 280px;
        height: 200px;
    }

    .media {
        margin-right: 0px;

    }
}
</style>
